import { Badge } from "@/components/ui/badge";

// Shared between StandardEntryView and ComputedEntryView's YearGroup headers
// — both compute the same figure (domains/dataEntry.js's
// formatCarbonEmissionReduction) and need to display it identically.
const CarbonEmissionReductionBadge = ({ value }) => {
  if (!value) return null;

  return (
    <Badge variant="default" className="text-sm">
      Carbon Emission Reduction : {value}
    </Badge>
  );
};

export default CarbonEmissionReductionBadge;
